/* PANCERX Dobieracz v3 - wspolny silnik liczacy. Wszystkie koncepcje wizualne MUSZA go uzywac bez zmian.
   Zrodla: karta techniczna ARMOR (wydajnosc wg calkowitej grubosci warstwy suchej), rozpisanie
   elementow kompaktu skalowane na klasy, kafelki "Ile puszek" (relacja BLACK:COLOR). */
(function (g) {
  var ZESTAW_L = 0.8, PROG = 0.55, ZAPAS = 0.15, MAX = 500;
  var KLASY = [
    { id: 'maly',    nm: 'Mały',        ex: 'Seicento, Smart' },
    { id: 'kompakt', nm: 'Kompakt',     ex: 'Golf, Focus' },
    { id: 'duzy',    nm: 'Duży',        ex: 'Passat, A6' },
    { id: 'suv',     nm: 'SUV / pickup', ex: 'Hilux, Amarok' },
    { id: 'van',     nm: 'Furgon',      ex: 'Ducato, Transit' }
  ];
  /* m2 w kolejnosci KLASY. blotniki w furgonie = sciany ladowni. */
  var CZESCI = [
    { id: 'podwozie',  nm: 'Podwozie',        m2: [5.8, 7.6, 10.3, 12.5, 11.4] },
    { id: 'nadkola',   nm: 'Nadkola',         m2: [1.5, 1.8,  2.4,  3.1,  2.3] },
    { id: 'progi',     nm: 'Progi',           m2: [0.4, 0.5,  0.7,  0.8,  0.8] },
    { id: 'zderzak_p', nm: 'Zderzak przód',   m2: [0.6, 0.8,  1.0,  1.3,  0.9] },
    { id: 'zderzak_t', nm: 'Zderzak tył',     m2: [0.6, 0.8,  1.0,  1.3,  0.9] },
    { id: 'dach',      nm: 'Dach',            m2: [1.3, 1.6,  2.2,  2.7,  8.3] },
    { id: 'maska',     nm: 'Maska',           m2: [1.0, 1.3,  1.9,  2.3,  1.1] },
    { id: 'klapa',     nm: 'Klapa',           m2: [0.8, 1.1,  1.5,  1.9,  2.9] },
    { id: 'drzwi',     nm: 'Drzwi',           m2: [1.7, 2.4,  3.1,  3.8,  4.3] },
    { id: 'blotniki',  nm: 'Błotniki',        m2: [1.7, 2.2,  3.0,  3.5, 10.0], nmVan: 'Ściany ładowni' },
    { id: 'bagaznik',  nm: 'Wnętrze ładowni', m2: [1.9, 2.3,  3.1,  4.0, 12.8] }
  ];
  /* Sposob nakladania -> zuzycie na GOTOWA robote (2 warstwy), nie na jedno przejscie.
     Kalibracja 2026-09-07 wg liczb wlasciciela: walkiem idzie grubsza warstwa i kryje slabiej,
     pistoletem material jest rozcienczony, kladzie sie rowniej i kryje lepiej - schodzi go ok. 15%
     mniej (6,0 -> 7,06 m2/l, czyli 6,0 / 0,85). 6,0 m2/l to linia 70 um z karty ARMOR.
     Zaokraglanie: walek zawsze w gore, pistolet do najblizszej puszki (w wyliczeniu jest juz
     15% zapasu, a natrysk kladzie rowniej) - bez tego liczby wlasciciela nie schodza sie co do jednej. */
  var APLIKACJA = {
    walek:    { nm: 'Wałek',    wyd: 6.00, zaokr: 'gora',   um: 'grubsza warstwa' },
    pistolet: { nm: 'Pistolet', wyd: 7.06, zaokr: 'blisko', um: 'lepsze krycie' }
  };
  var PRODUKT = { black: { nm: 'ARMOR BLACK', mnoz: 1.0 }, color: { nm: 'ARMOR COLOR', mnoz: 1.2 } };
  /* Kolory: lum = jasnosc 0..1, hide = sila krycia koloru DOCELOWEGO 0..1, hue = kat (null = achromatyczny). */
  var KOLORY = [
    { id: 'bialy',        nm: 'Biały',        hex: '#F2F2F2', lum: 0.90, hide: 0.60, hue: null },
    { id: 'srebrny',      nm: 'Srebrny',      hex: '#B9BEC3', lum: 0.55, hide: 0.65, hue: null },
    { id: 'szary',        nm: 'Szary',        hex: '#6E7378', lum: 0.30, hide: 0.90, hue: null },
    { id: 'czarny',       nm: 'Czarny',       hex: '#141414', lum: 0.04, hide: 1.00, hue: null },
    { id: 'czerwony',     nm: 'Czerwony',     hex: '#C8102E', lum: 0.18, hide: 0.45, hue: 350 },
    { id: 'pomaranczowy', nm: 'Pomarańczowy', hex: '#E8740C', lum: 0.35, hide: 0.40, hue: 28 },
    { id: 'zolty',        nm: 'Żółty',        hex: '#F2C300', lum: 0.60, hide: 0.30, hue: 48 },
    { id: 'zielony',      nm: 'Zielony',      hex: '#2E7D32', lum: 0.18, hide: 0.60, hue: 123 },
    { id: 'niebieski',    nm: 'Niebieski',    hex: '#1F4E9C', lum: 0.12, hide: 0.65, hue: 218 },
    { id: 'brazowy',      nm: 'Brązowy',      hex: '#6B4A2B', lum: 0.12, hide: 0.80, hue: 29 },
    { id: 'bezowy',       nm: 'Beżowy',       hex: '#D9C7A1', lum: 0.60, hide: 0.75, hue: 41 }
  ];
  function kolor(id) { for (var i = 0; i < KOLORY.length; i++) if (KOLORY[i].id === id) return KOLORY[i]; return null; }
  function kontrast(a, b) {
    if (!a || !b) return 0;
    var lum = Math.abs(a.lum - b.lum) * 1.2, hue = 0;
    if (a.hue === null && b.hue === null) hue = 0;
    else if (a.hue === null || b.hue === null) hue = 0.5;
    else { var d = Math.abs(a.hue - b.hue) % 360; hue = (d > 180 ? 360 - d : d) / 180; }
    return Math.min(1, lum + hue * 0.3);
  }
  /* Kara za brak podkladu: 0..0.60. Liczy sie jak slabo kryje kolor DOCELOWY i o ile jest jasniejszy
     od obecnego (jasny na ciemnym to najgorszy przypadek). Kalibracja 2026-09-07:
     bialy->czerwony +26%, czarny->pomaranczowy +53%, brazowy->zolty +60% (max),
     cokolwiek->czarny 0% (czern kryje wszystko), ten sam kolor 0%. */
  function karaKoloru(produkt, podklad, terazId, celId) {
    if (podklad) return 0;
    var teraz = kolor(terazId), cel = produkt === 'black' ? kolor('czarny') : kolor(celId);
    if (!teraz || !cel) return 0;
    var slabe = 1 - cel.hide, jasnienie = Math.max(0, cel.lum - teraz.lum);
    return Math.min(0.60, Math.round((0.4727 * slabe * kontrast(teraz, cel) + 2.0803 * slabe * jasnienie) * 100) / 100);
  }
  function plural(n, loc) {
    var f = { pl: ['puszka', 'puszki', 'puszek'], sk: ['plechovka', 'plechovky', 'plechoviek'], en: ['tin', 'tins', 'tins'], de: ['Dose', 'Dosen', 'Dosen'] }[loc || 'pl'];
    if (loc === 'sk') return n === 1 ? f[0] : (n >= 2 && n <= 4 ? f[1] : f[2]);
    if (loc && loc !== 'pl') return n === 1 ? f[0] : f[2];
    var a = n % 10, b = n % 100;
    if (n === 1) return f[0];
    if (a >= 2 && a <= 4 && !(b >= 12 && b <= 14)) return f[1];
    return f[2];
  }
  /* st = { tryb:'czesci'|'wymiary', klasa, czesci:{id:1}, produkt:'black'|'color', aplikacja:'walek'|'pistolet',
            podklad:true|false, kolorTeraz:id, kolorCel:id, wym:{ks:'furgon'|'skrzynia'|'plaska', L,W,H, sciany:{boki,dach,przod_tyl,podloga}} } */
  function policz(st) {
    var poz = [], msg = null;
    if (st.tryb === 'wymiary') {
      var w = st.wym || {}, L = +w.L || 0, W = +w.W || 0, H = +w.H || 0, ks = w.ks || 'furgon', sc = w.sciany || {};
      if (!(L > 0 && W > 0) || (ks !== 'plaska' && !(H > 0))) msg = 'Wpisz wymiary';
      else if (ks === 'plaska') poz.push({ nm: 'Powierzchnia', v: L * W });
      else {
        var Hb = Math.max(H - PROG, 0.1);
        if (sc.boki) poz.push({ nm: 'Boki', v: 2 * L * Hb * 0.95 });
        if (sc.dach) poz.push({ nm: 'Dach', v: L * W * 0.92 });
        if (sc.przod_tyl) poz.push({ nm: 'Przód i tył', v: W * Hb * 1.35 });
        if (sc.podloga) poz.push({ nm: 'Podłoga', v: L * W });
        if (ks === 'furgon' && (sc.boki || sc.przod_tyl)) poz.push({ nm: 'Przeszklenie kabiny', v: -2.8 });
        if (!poz.length) msg = 'Zaznacz ściany';
      }
    } else {
      var ki = 0; for (var i = 0; i < KLASY.length; i++) if (KLASY[i].id === st.klasa) ki = i;
      CZESCI.forEach(function (c) { if (st.czesci && st.czesci[c.id] && c.m2[ki] > 0) poz.push({ nm: (st.klasa === 'van' && c.nmVan) ? c.nmVan : c.nm, v: c.m2[ki] }); });
      if (!poz.length) msg = 'Zaznacz, co malujesz';
    }
    var m2 = poz.reduce(function (a, p) { return a + p.v; }, 0);
    var ap = APLIKACJA[st.aplikacja] || APLIKACJA.walek, pr = PRODUKT[st.produkt] || PRODUKT.black;
    var kara = karaKoloru(st.produkt, st.podklad !== false, st.kolorTeraz, st.kolorCel);
    var naZ = ZESTAW_L * ap.wyd, potrzeba = m2 * (1 + ZAPAS) * pr.mnoz * (1 + kara);
    var surowe = potrzeba / naZ;
    var puszki = m2 > 0 ? (ap.zaokr === 'blisko' ? Math.max(1, Math.floor(surowe + 0.5)) : Math.ceil(surowe)) : 0;
    if (puszki > MAX) { puszki = 0; msg = 'Sprawdź wymiary'; }
    if (m2 <= 0 && !msg) msg = 'Zaznacz, co malujesz';
    return { m2: m2, poz: poz, aplikacja: ap, produkt: pr, kara: kara, zapas: ZAPAS, potrzeba: potrzeba, naZestaw: naZ, puszki: puszki, msg: puszki ? null : msg };
  }
  g.PXEngine = { KLASY: KLASY, CZESCI: CZESCI, APLIKACJA: APLIKACJA, PRODUKT: PRODUKT, KOLORY: KOLORY, policz: policz, plural: plural, karaKoloru: karaKoloru, kolor: kolor };
})(typeof window !== 'undefined' ? window : globalThis);
